import { render, staticRenderFns } from "./CollaboratorProfile.vue?vue&type=template&id=30e47cee&"
import script from "./CollaboratorProfile.vue?vue&type=script&lang=js&"
export * from "./CollaboratorProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports